<app-dialogue-box [isDialogOpen]="isDialogOpen" [title]="dialogTexts.DELETE_REPORT.TITLE"
  [message]="dialogTexts.DELETE_REPORT.MESSAGE" [confirmButtonText]="dialogTexts.DELETE_REPORT.CONFIRM"
  (onClose)="closeDialog()" (onConfirm)="deleteReport(selectedReportId)">
</app-dialogue-box>
<app-loader *ngIf="isLoading"></app-loader>
<div class="report-list-container">
  <div class="report-list-header">
    <span class="user-welcome">Hello, {{name}}</span>
  </div>
  <app-chart-data (dateRangeSelected)="onDateRangeChange($event)"></app-chart-data>
  <div class="list-header">
    <h2><span class="report-count">{{reports().length}}</span> Recent Reports</h2>
    <div class="header-actions">
      <button class="all-reports" (click)="loadReports()">
        <img src="/assets/icons/report_green.svg" alt="All Reports" />
        Refresh Reports
      </button>
      <button class="filters" (click)="enableGridFilters()">
        <img src="/assets/icons/filter_alt_32.svg" alt="Filters" />
        Filters
      </button>
    </div>
  </div>
  <div class="grid-wrapper">
    <ag-grid-angular class="custom-grid" style="width: 100%; height: 100%;"
      [rowData]="reports()" 
      [columnDefs]="columnDefs" 
      [context]="{ componentParent: this }"
      overlayNoRowsTemplate="No reports found" 
      [headerHeight]="40" 
      [gridOptions]="gridOptions" 
      [defaultColDef]="{
        sortable: false,
        resizable: true,
        filter: this.isFilterEnabled,
        flex: 1,
        minWidth: 180
      }"
      [suppressDragLeaveHidesColumns]="true">
    </ag-grid-angular>
  </div>
</div>